import React, { useEffect, useRef, useState } from "react";
import { useStoreon } from "storeon/react";
import { useParams, useHistory } from "react-router-dom";
import { BLOG_GET_BY_ID } from "../../core/store/blog";
import "./post.scss";
import ShareButton from "../share-button/share-button";
import arrowBack from "../../assets/img/arrow-back-gray.svg";
import arrowNext from "../../assets/img/arrow-next-gray.svg";
import { Link } from "react-router-dom";
import moment from "moment";
import { FavoriteButton } from "../favorite-button/favorite-button";

export default function Post({
  postId,
  onBack,
  onRefreshItems,
  onSelectOtherCategoryBlog,
}) {
  const { blogId } = useParams();
  const param = blogId && parseInt(blogId.split("-")[0]);
  const currentPostId = param || postId;
  const [post, setPost] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const pagination = useRef(new Map()).current;

  const {
    blog: { posts, config },
    dispatch,
  } = useStoreon("blog");

  const history = useHistory();

  const formatDate = (date) => moment(date).format("MMMM DD, YYYY");

  const getShareLink = () => window.location.href;

  useEffect(() => {
    if (posts.length) {
      let currentPostIndex = -1;
      const post = posts.find((p, index) => {
        currentPostIndex = index;
        return p.id === currentPostId;
      });

      if (post) {
        pagination.clear();
        let prev = currentPostIndex - 1;
        let next = currentPostIndex + 1;
        if (prev !== -1) pagination.set("PREV", posts[prev]);
        if (next <= posts.length - 1) pagination.set("NEXT", posts[next]);
        setPost(post);
        setIsLoaded(true);
      } else {
        processPostNotIncludedInPosts(config?.carousel_section);
      }
    } else {
      processPostNotIncludedInPosts(config?.carousel_section);
    }
  }, [currentPostId, posts]);

  const processPostNotIncludedInPosts = (main) => {
    main?.category && main?.id === currentPostId
      ? onSelectOtherCategoryBlog(main.category)
      : handleGetById();
  };

  const handleGetById = () => {
    dispatch(BLOG_GET_BY_ID, { postId: currentPostId, history });
  };

  const PostSkeleton = () => (
    <>
      <div className="skeleton_blog-detail__wrapper">
        <div className="skeleton_blog-detail__post-action">
          <div className="skeleton_blog-detail__post-action_back"></div>
          <div className="skeleton_blog-detail__post-action_shared"></div>
        </div>
        <div className="skeleton_blog-detail__post-title"></div>
        <div className="skeleton_blog-detail__post-image"></div>
        <div className="skeleton_blog-detail__post-body"></div>
      </div>
    </>
  );

  const handleOnBack = () => {
    onBack && onBack();
  };

  return (
    <>
      {!isLoaded ? (
        <PostSkeleton />
      ) : post ? (
        <div id="blog_detail" className="blog-detail__wrapper">
          <div className="blog-detail__post_wrapper">
            <div className="blog-detail__post-actions">
              <div>
                {/* BACK */}
                <a onClick={handleOnBack} className="blog-detail__arrow-back">
                  <img src={arrowBack} alt="" />
                  <span>{config?.back_label}</span>
                </a>

                {/* TITLE */}
                <header className="blog-detail__post-title">
                  <h3>{post?.title}</h3>
                  <p>By {post?.writer?.name}</p>
                  <p>{formatDate(post?.date)}</p>
                </header>
              </div>
              {/* SOCIAL */}
              <div className="blog-detail__share-buttons">
                {/* SHARE BUTTON */}
                <ShareButton
                  label={config?.share_label}
                  successMsg={config?.successfully_shared_label}
                  isShowTitle={true}
                  shareLink={getShareLink()}
                  copyLink={getShareLink()}
                  type="SHARE"
                  isTooltip
                />
                {/* LIKE BUTTON*/}
                <FavoriteButton
                  onRefreshItems={onRefreshItems}
                  favoriteId={post?.favorite}
                  itemId={post?.id}
                  isShowTitle={true}
                />
              </div>
            </div>

            {/* POST */}
            <article className="blog-detail__post">
              {/* TITLE */}
              <header className="blog-detail__post-title">
                <h2>{post?.title}</h2>
                <p>
                  By {post?.writer?.name} on {formatDate(post?.date)}
                </p>
              </header>

              {/* PICTURE */}
              {post?.thumbnail_video ? (
                <div className="blog-detail__post-image">
                  <video
                    src={post?.image.url}
                    controls
                    poster={post?.thumbnail_video.url}
                  />
                </div>
              ) : (
                <figure className="blog-detail__post-image">
                  <img src={post?.image?.url} alt="" />
                </figure>
              )}

              {/* DESCRIPTION */}
              <div className="blog-detail__post-body">
                <p
                  dangerouslySetInnerHTML={{
                    __html: post?.body,
                  }}
                />
              </div>
            </article>
          </div>

          {/* PAGINATION*/}
          <footer className="blog-detail__post-footer">
            <div className="blog-detail__post-footer-prev">
              {/* PREV */}
              {pagination.has("PREV") && (
                <>
                  <Link
                    to={`/blog/${pagination.get("PREV").id}-${
                      pagination.get("PREV").slug
                    }`}
                  >
                    <div>
                      <img src={arrowBack} alt="" />
                      <span>{config.previous_article_label}</span>
                    </div>
                  </Link>
                  <Link
                    to={`/blog/${pagination.get("PREV").id}-${
                      pagination.get("PREV").slug
                    }`}
                  >
                    {pagination.get("PREV").title}
                  </Link>
                  <p>By {pagination.get("PREV").writer?.name}</p>
                </>
              )}
            </div>

            {/* NEXT */}
            <div className="blog-detail__post-footer-next">
              {pagination.has("NEXT") && (
                <>
                  <Link
                    to={`/blog/${pagination.get("NEXT").id}-${
                      pagination.get("NEXT").slug
                    }`}
                  >
                    <div>
                      <span>{config.next_article_label}</span>
                      <img src={arrowNext} alt="" />
                    </div>
                  </Link>
                  <Link
                    to={`/blog/${pagination.get("NEXT").id}-${
                      pagination.get("NEXT").slug
                    }`}
                  >
                    {pagination.get("NEXT").title}
                  </Link>
                  <p>By {pagination.get("NEXT").writer?.name}</p>
                </>
              )}
            </div>
          </footer>
        </div>
      ) : (
        <>
          {config?.back_label && (
            <div id="blog_detail" className="blog-detail__wrapper">
              <div className="blog-detail__post_wrapper">
                <div className="blog-detail__post-actions">
                  <div>
                    {/* BACK */}
                    <a
                      onClick={() => onBack && onBack()}
                      className="blog-detail__arrow-back"
                    >
                      <img src={arrowBack} alt="" />
                      <span>{config?.back_label}</span>
                    </a>
                  </div>
                </div>
                <article className="blog-detail__post">
                  {/* TITLE */}
                  <header className="blog-detail__post-title">
                    <h3 className="post-detail__not_found">
                      {config?.search_not_item_label}
                    </h3>
                  </header>
                </article>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}
